import { SkeletonBone } from "../../ui/skeleton";

export function WorkspaceSkeletonForm({ fields = 4 }) {
  return (
    <div className="flex flex-col gap-6" aria-hidden>
      {Array.from({ length: fields }).map((_, index) => (
        <div key={index} className="flex flex-col gap-2">
          <SkeletonBone className="h-4 w-32" />
          <SkeletonBone className="h-11 w-full rounded-lg" />
        </div>
      ))}
      <SkeletonBone className="mx-auto mt-2 h-12 w-64 rounded-3xl" />
    </div>
  );
}
